import type { CSSProperties } from 'react';
import SignOutIconSvg from '../../assets/icons/sign_out.svg?react';

export interface IconProps {
    size?: number | string;
    className?: string;
    style?: CSSProperties;
    onClick?: () => void;
}

const SignOutIcon: React.FC<IconProps> = ({ size = 16, className = '', style = {}, onClick }) => {
    const iconStyle: CSSProperties = {
        width: typeof size === 'number' ? `${size}px` : size,
        height: typeof size === 'number' ? `${size}px` : size,
        display: 'inline-block',
        fill: 'currentColor',
        ...style,
    };

    return <SignOutIconSvg className={className} style={iconStyle} onClick={onClick} />;
};

export default SignOutIcon;
